import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {fetchUsers} from "../../../creators/users";

import {Button} from "../../components/Button";
import Title from "../../components/Title";
import Aqp from "../../../libs/mk-react-aqp";
import {LoadingBar} from "../../components/Loader";
import history from "../../../libs/history";
import Avatar from "../../components/Avatar";
import {Link} from "react-router-dom";
import createLink from "../../../libs/createLink";
import DateSince from "../../components/Date";
import {config} from "../../../config";
import {canonical} from "../../../libs/helper";
import Helmet from "react-helmet";
import Pagination from "../../components/Pagination";
import {fetchTags, resetTags} from "../../../creators/tags";
// import TagList from "../../components/TagList";
import _ from "lodash";



class Search extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            // gender: false,
            limit: 30,
            page: 1,
            sort: "username"
        };
        let searchUsername = (this.props.match && this.props.match.params && this.props.match.params.searchUsername) || "";
        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page', 'searchUsername'],
            currentLink: "/recherche/"+ searchUsername,
            filterDefault: this.filter
        });

        this.state = {
            filter: {...this.filter, searchUsername, ...this.aqp.query, page: this.props.match.params.page || 1},
        };
        this.getUsers(this.state.filter);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleInputContent = this.handleInputContent.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(nextProps.match.params.searchUsername !== this.props.match.params.searchUsername){
            this.aqp.setCurrentLink("/recherche/"+ nextProps.match.params.searchUsername);
            let filter = {...this.state.filter, searchUsername : nextProps.match.params.searchUsername, page: 1};
            this.getUsers(filter);
        }
        return true;
    }

    getUsers(filter) {
        filter = {...filter};
        this.setState({filter});
        if(filter.searchUsername && filter.searchUsername.length >=2){
            this.props.fetchUsers(this.aqp.set(filter));
            this.fetchTag(filter.searchUsername);
        }
    }

    fetchTag(string = ""){
        string = string.replace(/[^a-zA-Z0-9 ]/g,'');
        // this.props.fetchTags({search : string, limit : 30});
    }

    handleInputContent(value) {
        let filter = {...this.state.filter, searchUsername : value};
        this.setState({filter});
    }

    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        let filter = {...this.state.filter, page : 1};
        this.getUsers(filter);
        history.push(`/recherche/${this.state.filter.searchUsername}`);
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getUsers(filter);
        window.scrollTo(0, 0);
    }

    render() {
        // let basicTagLink = this.props.match.url;
        let totalPage = this.props.users ? Math.ceil(this.props.usersTotal / this.state.filter.limit) : 0;
        return (
            <Fragment>
                <Helmet>
                    <title>{config.preTitle}Recherche{config.postTitle}</title>
                    <link rel="canonical" href={canonical(createLink("dating"))} />
                </Helmet>
                <div id={"search"}>
                    <div className={"card big container"}>
                        <Title heading={"heading-2"} display={"display-2"} className={"page-title ptb-64"}>Rechercher un Voissanaute</Title>
                        <div className={"pb-16 text-align-center"}><Link to={createLink("dating")}>Cliquez ici</Link> pour chercher tous les voissanautes cherchant à faire des rencontres.</div>
                        <form onSubmit={this.onSubmit}>
                            <div className={"search-bar"}>
                                <input placeholder={"Rechercher un Voissanaute"}
                                       type={"text"}
                                       value={this.state.filter.searchUsername}
                                       onChange={(event) => this.handleInputContent(event.target.value)}
                                />
                                <Button btnType={"submit"} size={"medium"}
                                        btnStyle={"primary-reverse"}
                                        content={"Rechercher"}
                                />
                            </div>
                        </form>
                        {this.props.usersLoading && (
                            <LoadingBar />
                        )}
                        <div className={"list"}>
                            {Array.isArray(this.props.users) && this.props.users.map((item) => {
                                return <div className="user" key={item._id}>
                                    <Avatar gender={_.get(item,"profile.gender") || 0} avatar={_.get(item,"profile.avatar") || ""}/>
                                    <div className="infos">
                                        <span className="username"><Link to={createLink("userProfile", item)}>{item.username}</Link></span>

                                        <span className="sub-infos">{`Membre depuis : `}
                                            <DateSince
                                                date={item.createdAt}
                                                prefix={false}
                                                currentFormat={false}
                                                format={"DD/MM/YYYY"}
                                            />
                                        </span>
                                        {/*<span className="sub-infos">{item.role} · {(item.count && item.count.comment) || 0} messages</span>*/}
                                    </div>
                                </div>
                            })}
                        </div>
                        {!this.props.usersLoading && this.props.usersTotal === 0 && (
                            <div className={"no-content"}>Aucun utilisateur</div>
                        )}
                        {totalPage > 1 && (
                            <Pagination
                                currentPage={this.state.filter.page}
                                pagesCount={totalPage}
                                {...this.aqp.queryUrl(this.state.filter)}
                                handleChangePage={this.handleChangePage}
                            />
                        )}
                        {/*{this.props.usersInitialized && (<div>*/}
                        {/*    /!*<Title heading={"heading-2"} display={"display-2"} className={"page-title pt-16"}>Rechercher un Tag</Title>*!/*/}
                        {/*    <TagList type={"tagVideo"} tags={this.props.tags || []}/>*/}
                        {/*</div>)}*/}
                    </div>
                </div>

            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        usersInitialized: state.users.initialized,
        users: state.users.data,
        usersLoading: state.users.loading,
        usersTotal: state.users.total,

        tags: state.tags.data,
        tagsInitialized : state.tags.initialized,
        tagsLoading : state.tags.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUsers,
    resetTags,
    fetchTags
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Search);